export const tabListData = [
    // {
    //     label: "Application",
    //     value: "application"
    // },
    // {
    //     label: "Menu",
    //     value: "menu"
    // },
    {
        label: "CONF_MENU_PERM",
        value: "function"
    },
    {
        label: "CONF_MENU_ROLE",
        value: "role"
    },
    {
        label: "CONF_MENU_USER",
        value: "user"
    },
    {
        label: "CONF_MENU_CLIENT",
        value: "about"
    }
]

export const profileTabListData = [
     {
        label: "PROF_MENU_BI",
        value: "basicInformation"
    },
     {
        label: "PROF_MENU_ES",
        value: "emailSettings"
    }

]
export const profileTabPannelName = {
    basicInformation: "basicInformation",
    emailSettings : "emailSettings",
}

export const tabPannelName = {
    // application: "application",
    // menu: "menu",
    function: "function",
    role: "role",
    user: "user",
    customization: "customization",
    about: "about",
    internationalise: "internationalise"
}

export const applicationSearchName = {
    applicationCode: "applicationCode",
    applicationStatus: "applicationStatus",
    applicationName: "applicationName",
}

export const applicationSearchLabel = {
    applicationCode: "Application Code",
    applicationStatus: "Application Status",
    applicationName: "Application Name"
}

export const ownerSearchName = {
    firstname: "firstname",
    lastname: "lastname",
    mobile: "mobile",
    department: "department",
    username: 'username'
}

export const ownerSearchLabel = {
    firstname: "First Name",
    lastname: "Last Name",
    mobile: "Phone",
    department: "Department",
    username: "Username",
    email: "Email"
}

export const companyLabel = {
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "mobile": "Mobile"
}

export const applicationStatusmenu = [
    {
        label: "Draft",
    },
    {
        label: "Active",
    },
    {
        label: "In-active",
    }
]

export const customizationSelectBox = [
    {
        label: "leadStatus",
    },
    {
        label: "Product"
    },
    // {
    //     label: "NotificationStatus"
    // },
    // {
    //     label: "NotificationType"
    // }
]

export const notificationStatus = [
    {
        label: "Active",
        value: 1,
        sequence: 1
    },
    {
        label: "In-Active",
        value: 2,
        sequence: 2
    }
]

export const notificationType = [
    {
        label: "Offer",
        value: 1,
        sequence: 1
    },
    {
        label: "Campaign",
        value: 2,
        sequence: 2
    },
    {
        label: "Warning",
        value: 3,
        sequence: 3
    }
]

export const notificationChannel = [
    {
        label: "Email",
        sequence: 1,
        value: 1,
    },
    {
        label: "Whatsapp",
        sequence: 2,
        value: 2,
    }
]
// Roles  Static Data

export const roleSearchName = {
    applicationCode: "roleCode",
    applicationStatus: "roleStatus",
    applicationName: "roleName"
}

export const roleSearchLabel = {
    applicationCode: "Role Code",
    applicationStatus: "Role Status",
    applicationName: "Role Name"
}

export const roleStatusmenu = [
    {
        label: "Draft",
    },
    {
        label: "Active",
    },
    {
        label: "In-active",
    }
]

// menu Static data

export const menuSearchName = {
    applicationCode: "menuCode",
    applicationStatus: "menuStatus",
    applicationName: "menuName"
}

export const menuSearchLabel = {
    applicationCode: "Menu Code",
    applicationStatus: "Menu Status",
    applicationName: "Menu Name"
}

export const menuStatusmenu = [
    {
        label: "Draft",
    },
    {
        label: "Active",
    },
    {
        label: "In-active",
    }
]

//Function static data

export const functionSearchName = {
    applicationCode: "functionCode",
    applicationStatus: "functionStatus",
    applicationName: "functionName"
}

export const functionSearchLabel = {
    applicationCode: "Permission Code",
    applicationStatus: "Permission Status",
    applicationName: "Permission Name"
}

export const dropDownFieldLabel = {
    type: "Type",
    sequence: "Sequence",
    value: "Value"
}

export const dropDownFieldName = {
    type: "type",
    sequence: "sequence",
    value: "value"
}


export const funnctionStatusmenu = [
    {
        label: "Draft",
    },
    {
        label: "Active",
    },
    {
        label: "In-active",
    }
]

//User static data

export const userSearchName = {
    applicationCode: "userCode",
    applicationStatus: "userStatus",
    applicationName: "userName"
}

export const userSearchLabel = {
    applicationCode: "User Code",
    applicationStatus: "User Status",
    applicationName: "User Name"
}

export const userStatusmenu = [
    {
        label: "Draft",
    },
    {
        label: "Active",
    },
    {
        label: "In-active",
    }
]


export const documentType = [
    {
        label: "KYC",
        value: "kyc"
    },
    {
        label: "Product layout",
        value: "layout"
    }
]
